import React from 'react'

const AddressField = ({
  street = '',
  city = '',
  postcode = '',
  country = '',
  changeHandler,
  required = false,
  labelClass,
  inputClass,
  style = {},
  id,
  ...props
}) => {
  return (
    <div style={style} id={id}>
      <label className={labelClass} htmlFor='street'>
        Street {required ? ' *' : ''}
      </label>
      <input
        type='text'
        className={inputClass}
        placeholder='Flat A, 123 Princes Street'
        name='street'
        id='street'
        value={street}
        onChange={changeHandler}
        required={required}
        style={{ width: '98%' }}
        {...props}
      />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gridColumnGap: '20px',
          marginTop: '10px'
        }}
      >
        <div>
          <label className={labelClass} htmlFor='city'>
            City {required ? ' *' : ''}
          </label>
          <input
            type='text'
            className={inputClass}
            placeholder='Edinburgh'
            name='city'
            id='city'
            value={city}
            onChange={changeHandler}
            required={required}
            {...props}
          />
        </div>
        <div>
          <label className={labelClass} htmlFor='postcode'>
            Postcode {required ? ' *' : ''}
          </label>
          <input
            type='text'
            className={inputClass}
            placeholder='EH1 2AB'
            name='postcode'
            id='postcode'
            value={postcode}
            onChange={changeHandler}
            required={required}
            {...props}
          />
        </div>
        <div>
          <label className={labelClass} htmlFor='country'>
            Country {required ? ' *' : ''}
          </label>
          <input
            type='text'
            className={inputClass}
            placeholder='UK'
            name='country'
            id='country'
            value={country}
            onChange={changeHandler}
            required={required}
            {...props}
          />
        </div>
      </div>
    </div>
  )
}

export default AddressField
